import React, { ReactNode } from "react";
import { Translate } from "components/common/Translate/Translate";
import LucideIconDynamic from "components/common/Icons/LucideIconDynamic";

export interface ISectionUseCase {
    title: string;
    subTitle: string;
    icon: string | ReactNode;
}

export interface ISectionUseCaseScaffoldProps {
    title: string | ReactNode;
    useCases: ISectionUseCase[];
}

export const SectionUseCaseScaffold = ({ title, useCases }: ISectionUseCaseScaffoldProps) => {
    return (
        <div className="mt-24 md:mt-[150px]">
            <div>
                <h2 className="text-24 font-semibold text-center dark:text-white">{title}</h2>
            </div>
            <div className=" mt-10 md:mt-[72px] grid grid-cols-1 md:grid-cols-2 gap-7 ">
                {useCases.map((e) => {
                    return (
                        <div
                            className="flex flex-col items-center  border-gray-100 px-8 py-10 rounded-xl dark:text-white"
                            key={e.title}
                            style={{
                                borderWidth: "1px",
                            }}
                        >
                            {typeof e.icon === "string" ? (
                                <div className="mb-4">
                                    {LucideIconDynamic({
                                        name: e.icon as string,
                                        strokeWidth: 1.5,
                                        width: 30,
                                        height: 30,
                                    })}
                                </div>
                            ) : (
                                <div className="mb-4">{e.icon} </div>
                            )}
                            <h3 className="mb-3 text-center font-semibold">
                                <Translate keyName={e.title} />
                            </h3>
                            <p className="text-center px-[10px]">
                                <Translate keyName={e.subTitle} />
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
